<template>
  <b-container>
    <div class="b-main-content">
      <h1>Welcome to the Greenbank Pulse Portal</h1>
      <p>
        You can use this portal to see the status of your machines.<br>
        <br>
        Login to see a list of your currently installed machines.<br>
        Click on a machine to see detailed status information.
      </p>
      <br>
      <h3>About Greenbank</h3>
      When you need effective waste management with great service, speak to Greenbank. We offer solutions that make waste management more efficient, saving your company time and money.
      <br><br>
      Visit our website <a href="https://greenbankwastesolutions.com">https://greenbankwastesolutions.com</a>
    </div>
  </b-container>
</template>

<script>
export default {
    
}
</script>

